import { useState } from 'react'
import { useFetchLogsByTable } from '../../../Queries/Logs/useFetchLogsByTable'
import CreatedLog from './createdLog'
import UpdatedLog from './updatedLog'
import UpdatedRole from './updatedRole'
import Loader from 'react-loaders'
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap'
import CustomTableReloadButton from '../../Common/customTableReloadButton'

const renderLog = (type, data, onExpand, expandedId, openRoleDetails) => {
  switch (type) {
    case 'create':
      return <CreatedLog data={data} onExpand={onExpand} expandedId={expandedId} openRoleDetails={openRoleDetails}></CreatedLog>
    case 'update':
      return <UpdatedLog data={data} onExpand={onExpand} expandedId={expandedId}></UpdatedLog>
    case 'role_update':
      return <UpdatedRole data={data} onExpand={onExpand} expandedId={expandedId} openRoleDetails={openRoleDetails}></UpdatedRole>
    default:
      return
  }
}

const PermissionLogs = ({ role_id, setActiveTab }) => {
  const [page,setPage] = useState()
  const { data, isLoading, refetch } = useFetchLogsByTable(role_id, 'roles_with_permisson',page)

  const [expandedId, setExpandedId] = useState()

  const onExpand = (id) => {
    setExpandedId(id)
  }
    if (!isLoading && data?.data?.length === 0)
      return (
        <div className='d-flex align-items-center justify-content-center' style={{ marginTop: '3rem' }}>
          <img src='not_found.png' style={{ width: '20rem' }}></img>
        </div>
      )
    if (data?.data?.length !== 0 && isLoading)
      return (
        <div style={{ display: 'flex', justifyContent: 'center', height: '10rem', alignItems: 'center' }}>
          <Loader type='ball-pulse' color='blue' />
        </div>
      )
  return (
    <div>
      <div className='float-right'>
        <CustomTableReloadButton onReload={() => refetch()} disabled={isLoading} id='permission-logs-reload' />
      </div>
      <div style={{ minHeight: '40vh' }}>
        {data?.data?.map((item, index) => {
          if (!expandedId) {
            return (
              <div key={index} className='p-3'>
                {renderLog(item?.type, item, onExpand, null, setActiveTab)}
              </div>
            )
          } else {
            if (expandedId === item?.id) {
              return (
                <div key={index} className='p-3'>
                  {renderLog(item?.type, item, onExpand, expandedId)}
                </div>
              )
            } else {
              return <></>
            }
          }
        })}
      </div>

      <div className='d-flex justify-content-center mt-4'>
        <Pagination aria-label='Page navigation example' style={{ flexWrap: 'wrap' }}>
          {data?.links?.map((item, key) => {
            return (
              <PaginationItem active={item.active} disabled={item.url === null} key={key}>
                <PaginationLink
                  first
                  className='subtitle2'
                  onClick={() => {
                    if (item?.label?.toLowerCase()?.includes('previous')) {
                      setPage(parseInt(data?.current_page) - 1)
                    } else if (item?.label?.toLowerCase()?.includes('next')) {
                      setPage(parseInt(data?.current_page) + 1)
                    } else {
                      setPage(parseInt(item?.label))
                    }
                  }}>
                  {item.label.replace('&laquo;', '').replace('&raquo;', '')}
                </PaginationLink>
              </PaginationItem>
            )
          })}
        </Pagination>
      </div>
    </div>
  )
}

export default PermissionLogs
